import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { useMantineTheme, Button, TextInput, Group } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { regexNumberOnly } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";

const ComponentInputJumlahPemakaianStock = ({
    stateKey,
    stateData,
    stateDataStock,
    statePengerjaanProgresId,
    fnRes
}) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'componentInputJumlahPemakaianStock-1',
    })

    const [data, setData] = React.useState({
        value: '',
        valueError: '',
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = () => {
        setData(d => ({ ...d, valueError: '' }));

        if (Number(data.value) === 0) {
            setData(d => ({ ...d, valueError: ' ' }));
        } else {
            setData(d => ({
                ...d,
                submitLoading: true,
            }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);
            formDT.append('progres_id', statePengerjaanProgresId);
            formDT.append('pengerjaan_progress_flag', utils.pengerjaanProgress.pengerjaan.value);

            formDT.append('stock_id', stateDataStock.stock_id);
            formDT.append('jumlah_pemakaian', data.value);

            axios({
                method: 'post',
                url: BE_API_TWO + '/input_jumlah_pemakaian_stock_pengerjaan_progres',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {
                    fnRes(response.data.data);
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'tagged-item') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: response.data.message,
                            show: true
                        }
                    }))
                }

                //
                if (response.data.flag_status === 'can-not-be-edit') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak dapt diubah !',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'stok-tidak-ada') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Stok item tidak ada ! Refresh halaman untuk mendapatkan data terbaru !',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'stok-tidak-cukup') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: `Jumlah stok part tidak mencukupi. Sisa stok saat ini adalah : ${response.data.stok_aktual}`,
                            show: true
                        }
                    }))
                }
                //

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    submitLoading: false,
                    modalShow: false
                }))

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Group noWrap spacing='xs' align='flex-start'>
                <TextInput
                    variant='default'
                    size="sm"
                    placeholder='Jumlah Pemakaian'
                    styles={() => ({
                        input: {
                            backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                        }
                    })}
                    sx={{ width: '100%' }}
                    value={data.value}
                    error={data.valueError}
                    onChange={(e) => setData(d => ({ ...d, value: regexNumberOnly(e.target.value) }))}
                />

                <Button
                    size="sm"
                    onClick={submitData}

                    loaderPosition="right"
                    loading={data.submitLoading}
                >
                    Pakai
                </Button>
            </Group>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default ComponentInputJumlahPemakaianStock;